var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTime = function SvgTime(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#time_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    d: "M8 1.333a6.667 6.667 0 1 1 0 13.333A6.667 6.667 0 0 1 8 1.333M8 4a.667.667 0 0 0-.667.666V8c0 .176.07.346.196.471l2 2a.667.667 0 0 0 .942-.943L8.667 7.724V4.666A.667.667 0 0 0 8 4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "time_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgTime;